import { Box, Grid2, Paper, Typography } from "@mui/material";
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import { SignalingConnection } from "../../api/signaling/SignalingConnection";
import { EditRobotProps } from "./Details";
import { useEffect, useState } from "react";
import { EnvironmentStatus, EnvironmentView } from "./EnvironmentView";
import { FileView } from "./FileView";

function EnvItemLabel({ item }: { item: any }) {
  return (
    <Grid2 direction={'row'} container sx={{ width: '250px' }}>
      <Box
        sx={{
          marginTop: '9px',
          width: 16,
          height: 16,
          borderRadius: "50%",
          backgroundColor: item.status
            ? item.status === EnvironmentStatus.Running
              ? "green"
              : item.status === EnvironmentStatus.Idle
                ? "orange"
                : "red"
            : "gray",
          mr: 1,
        }}
      />
      <Box style={{ width: "200px" }}>
        <Typography variant="h6" noWrap>
          {item.name}
        </Typography>
      </Box>
    </Grid2>
  );
}

function createTreeItems(parentId: string, itemsMap: any, onClick: any): JSX.Element[] {
  const items = Object.keys(itemsMap).map((key) => {
    const item = itemsMap[key];
    const treeItem = {
      id: parentId ? `${parentId}/${key}` : key,
      name: key,
      children: null as any,
      status: item.status,
    };
    if (typeof item === "object") {
      treeItem.children = { ...item } as any;
      if (treeItem.children?.status) {
        delete treeItem.children.status;
      }
    }
    return treeItem;
  });
  return items.map((item) => (
    <TreeItem
      key={item.id}
      itemId={item.id}
      onClick={() => onClick(item)}
      label={item.status ? <EnvItemLabel item={item} /> : item.name}
    >
      {item.children && createTreeItems(item.id, item.children, onClick)}
    </TreeItem>
  ));
}



// export interface PmStatus {
//   status: Status;
//   lastUpdate: number;
//   pmVersion: string;
//   environments: {
//     [key: string]: {
//       package: string;
//       installStatus: string;
//       components: {
//         [key: string]: {
//           status: Status;
//           lastUpdate: number;
//         };
//       };
//     };
//   };
// }



export interface EditRobotPropsLive extends EditRobotProps {
  pmStatus: any;
  signaling: SignalingConnection;
  alternateSignalingIP?: string;
}

export function FileSystemView({ pmStatus, signaling, robot, errors, alternateSignalingIP }: EditRobotPropsLive) {
  const [fs, setFs] = useState<any>(null);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  useEffect(() => {
    if (!signaling || !pmStatus) {
      return;
    }
    signaling.sendReplace({ fs: true });
    const handlerFs = (data: any) => {
      for (const key in data) {
        const subroot = data[key];
        subroot.status = EnvironmentStatus.Idle;
      }
      setFs(data);
    };
    signaling.addListener("fs", handlerFs);
    return () => {
      if (handlerFs) {
        signaling.removeListener("fs", handlerFs);
      }
    }
  }, [signaling]);
  useEffect(() => {
    if (!pmStatus) {
      return;
    }
    for (const key in pmStatus.environments) {
      const env = pmStatus.environments[key];
      if (!fs || !fs[key]) {
        continue;
      }
      fs[key].status = env.status;
      // console.log(fs[key].status);
    }
    setFs({ ...fs });
  }, [pmStatus]);


  function onItemClick(item: any) {
    setSelectedItem(item);
  }

  if (!fs) {
    return null;
  }
  //  defaultExpandedItems={expandedItems}
  return (
    <Box sx={{ height: "calc(100vh - 251px)", flexGrow: 1, margin: 0, padding: 0 }} component={Paper}>
      <Grid2 container direction={'row'} spacing={0} sx={{ margin: 0, padding: 0 }}>
        <Box sx={{ width: '360px', height: "calc(100vh - 251px)", overflow: "auto", background: "#2F2F2F" }}>
          <SimpleTreeView >
            {createTreeItems("", fs, onItemClick)}
          </SimpleTreeView>
        </Box>
        <Box sx={{ flexGrow: 1, xs: 9, overflow: "auto" }}>
          {(selectedItem && selectedItem.status) &&
            <EnvironmentView
              robot={robot}
              alternateSignalingIP={alternateSignalingIP}
              pmStatus={pmStatus}
              onChange={() => { }}
              errors={errors}
              item={selectedItem}
              signaling={signaling} />}
          {(selectedItem && !selectedItem.children) &&
            <FileView
              robot={robot}
              onChange={() => { }}
              errors={errors}
              pmStatus={pmStatus}
              item={selectedItem}
              signaling={signaling} />}
        </Box>
      </Grid2>
    </Box>
  );
}

// interface StatusItem {
//   id: string;
//   label: string;
//   status?: Status;
//   children?: StatusItem[];
//   parent?: StatusItem;
//   package?: string;
//   path: string;
//   type?: string;
// }

// enum Status {
//   Running = "running",
//   Stopped = "idle",
// }




// export function RobotStatusView({
//   pmStatus,
//   signaling,
// }: {
//   pmStatus: PmStatus;
//   signaling: SignalingConnection;
// }) {

//   const expandedItems = ["pmStatus", "environments"];

//   function createItems(pmStatus: PmStatus): StatusItem[] {
//     const items: StatusItem[] = [];
//     // console.log("pmStatus:", pmStatus);
//     items.push({
//       id: "pmStatus",
//       label: "Process Manager",
//       status: pmStatus.status,
//       package: pmStatus.pmVersion,
//       type: "pm",
//       path: "",
//       children: [
//         {
//           id: "environments",
//           label: "Environments",
//           path: "environments",
//           children: Object.entries(pmStatus.environments).map(
//             ([envName, env]) => ({
//               id: envName,
//               label: envName,
//               path: `${envName}`,
//               package: env.installStatus,
//               type: "environment",
//               children: Object.entries(env.components).map(
//                 ([compName, comp]) => ({
//                   id: `${envName}_${compName}`,
//                   label: compName,
//                   type: "component",
//                   status: comp.status,
//                   path: `${envName}/${compName}`,
//                 })
//               ),
//             })
//           ),
//         },
//       ],
//     });

//     return items;
//   }

//   function createTreeItems(items: StatusItem[]): JSX.Element[] {
//     return items.map((item) => (
//       <TreeItem
//         key={item.id}
//         itemId={item.id}
//         // onClick={() => console.log(item)}
//         label={
//           item.status ? (
//             <Box sx={{ display: "flex", alignItems: "center" }}>
//               <Box
//                 sx={{
//                   width: 8,
//                   height: 8,
//                   borderRadius: "50%",
//                   backgroundColor: item.status
//                     ? item.status === Status.Running
//                       ? "green"
//                       : item.status === Status.Stopped
//                         ? "orange"
//                         : "red"
//                     : "gray",
//                   mr: 1,
//                 }}
//               />
//               {item.type === 'pm' && (
//                 <>
//                   <span style={{ width: "18.5rem" }}>{item.label}/{item.package}</span>
//                   <ButtonGroup>
//                     <Button
//                       variant="contained"
//                       size="small"
//                       onClick={async () => {
//                         const yes = await showConfirmDialog("Restart", "Restart Process Manager?");
//                         if (!yes) {
//                           return;
//                         }
//                         signaling.sendReplace({ restart: 'pm' });
//                       }}
//                     >
//                       Restart
//                     </Button>
//                     <Button
//                       variant="contained"
//                       color="inherit"
//                       size="small"
//                       onClick={async () => {
//                         const version = await showInputDialog(
//                           "Upgrade PM",
//                           "Enter the version to upgrade to",
//                           item.package);
//                         if (!version) {
//                           return;
//                         }
//                         // console.log("Upgrade PM", version);
//                         signaling.sendReplace({ upgrade: `pm:${version}` });
//                       }}
//                     >
//                       Upgrade PM
//                     </Button>

//                   </ButtonGroup>
//                 </>
//               )}
//               {item.type === 'component' ? (
//                 <>
//                   <span style={{ width: "5rem" }}>{item.label}</span>
//                   <ButtonGroup sx={{ ml: 1 }}>
//                     <Button
//                       variant="contained"
//                       color="inherit"
//                       size="small"
//                       onClick={() => {
//                         console.log("Start", item.path);
//                         signaling.sendReplace({ start: item.path });
//                       }}
//                       disabled={item.status !== Status.Stopped}
//                     >
//                       Start
//                     </Button>
//                     <Button
//                       variant="contained"
//                       color="inherit"
//                       size="small"
//                       onClick={() => {
//                         console.log("Stop", item.path);
//                         signaling.sendReplace({ stop: item.path });
//                       }}
//                       disabled={item.status !== Status.Running}
//                     >
//                       Stop
//                     </Button>
//                   </ButtonGroup>
//                 </>
//               ) : null}
//             </Box>
//           ) : (
//             <>{
//               item.type === 'environment' ? (
//                 <>
//                   <div style={{ display: 'inline-block', width: '300px' }} >{item.label} [{item.package}]</div>
//                   <ButtonGroup>
//                   <Button
//                       variant="contained"
//                       color="inherit"
//                       size="small"
//                       onClick={() => {
//                         signaling.sendReplace({ upgrade: item.path });
//                       }}
//                     >
//                       Update
//                     </Button>
//                     <Button
//                       variant="contained"
//                       color="inherit"
//                       size="small"
//                       onClick={() => {
//                         signaling.sendReplace({ install: item.path });
//                       }}
//                     >
//                       Install
//                     </Button>

//                   </ButtonGroup>
//                 </>
//               )
//                 : item.path
//             }</>
//           )
//         }
//       >
//         {item.children && createTreeItems(item.children)}
//       </TreeItem>
//     ));
//   }

//   if (!pmStatus) {
//     return null;
//   }

//   return (
//     <Box sx={{ height: "calc(100vh - 251px)", flexGrow: 1 }} component={Paper}>
//       <SimpleTreeView defaultExpandedItems={expandedItems}>
//         {createTreeItems(createItems(pmStatus))}
//         {/* {createTreeItems(items)} */}
//       </SimpleTreeView>
//     </Box>
//   );
// }
